<template>
	<div>
		<el-card>
			<div slot="header" class="clearfix">
				<i class="el-icon-back backIcon" @click='goBack'></i>
				<span class="topTitle">{{addBody.uuid?'编辑资讯':'新增资讯'}}</span>
			</div>
			<el-tabs v-model="activeName" @tab-click="changeTab" v-if="addBody.uuid">
				<el-tab-pane label="中文" name="zh"></el-tab-pane>
				<el-tab-pane label="英文" name="en"></el-tab-pane>
				<el-tab-pane label="日语" name="jp"></el-tab-pane>
			</el-tabs>
			<el-form ref="addBody" :rules="rules" :model="addBody" label-position='top'>
				<el-form-item label="资讯标题"
					:prop="activeName === 'zh' ? 'title' : activeName === 'en' ? 'title_e' : 'title_j'"
					:label-width="formLabelWidth">
					<el-input v-if="activeName === 'zh'" v-model="addBody.title" style="width: 766px;"></el-input>
					<el-input v-if="activeName === 'en'" v-model="addBody.title_e" style="width: 766px;"></el-input>
					<el-input v-if="activeName === 'jp'" v-model="addBody.title_j" style="width: 766px;"></el-input>
				</el-form-item>

				<el-form-item label="封面" 
					:label-width="formLabelWidth">
					<ImageUpload v-show="activeName === 'zh'" @input="imgInput" :onloadImageList="imgList" :limit="1"
						type="image"></ImageUpload>
					<ImageUpload v-show="activeName === 'en'" @input="imgInputEn" :onloadImageList="imgListEn" :limit="1"
						type="image"></ImageUpload>
					<ImageUpload v-show="activeName === 'jp'" @input="imgInputJp" :onloadImageList="imgListJp" :limit="1"
						type="image"></ImageUpload>
				</el-form-item>

				<el-form-item label="描述"
					:prop="activeName === 'zh' ? 'desc' : activeName === 'en' ? 'desc_e' : 'desc_j'"
					:label-width="formLabelWidth">
					<el-input v-if="activeName === 'zh'" type="textarea" :rows="6" v-model="addBody.desc"
						style="width: 766px;"></el-input>
					<el-input v-if="activeName === 'en'" type="textarea" :rows="6" v-model="addBody.desc_e"
						style="width: 766px;"></el-input>
					<el-input v-if="activeName === 'jp'" type="textarea" :rows="6" v-model="addBody.desc_j"
						style="width: 766px;"></el-input>
				</el-form-item>

				<el-form-item label="所属类目" :label-width="formLabelWidth">
					<el-select v-model="addBody.category_id" @change="network().changeCategory()" style="width: 766px;"
						placeholder="请选择所属类目">
						<el-option v-for="item in lmList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="分类" v-if="addBody.category_id" prop="sub_category_id"
					:label-width="formLabelWidth">
					<el-select v-model="addBody.sub_category_id" style="width: 766px;" placeholder="请选择分类">
						<el-option v-for="item in subCategorys" :key="item.uuid" :label="activeName === 'zh' ? item.title: activeName === 'en' ?item.title_e: item.title_j" :value="item.uuid">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="详情"
					:prop="activeName === 'zh' ? 'detail' : activeName === 'en' ? 'detail_e' : 'detail_j'"
					:label-width="formLabelWidth">
					<!-- MdEditor for Chinese -->
					<div v-show="activeName === 'zh'" style="width: 100%;">
						
						<v-md-editor  mode="editable"
						left-toolbar="undo redo clear | h bold italic strikethrough quote | ul ol table hr | link  customimage"
						right-toolbar="aiContinue aiCreation aiCorrection aiTranslation aiDraw "  v-model="addBody.detail" ref="mdEditor" height="400px"  :toolbar="toolbarConfig" >
					</v-md-editor>
					</div>
					<!-- MdEditor for English -->
					<div v-show="activeName === 'en'" style="width: 100%;">
						<v-md-editor
							ref="mdEditorEn"
							 mode="editable"
							 left-toolbar="undo redo clear | h bold italic strikethrough quote | ul ol table hr | link customimage"
							right-toolbar="aiContinue aiCreation aiCorrection aiTranslation aiDraw "
							v-model="addBody.detail_e"
							height="400px"
							@upload-image="onUploadImg"
							:toolbar="toolbarConfig"
						>
							
						</v-md-editor>
					</div>
					<!-- MdEditor for Japanese -->
					<div v-show="activeName === 'jp'" style="width: 100%;">
						<v-md-editor
							ref="mdEditorJp"
							v-model="addBody.detail_j"
							height="400px"
							 mode="editable"
							 left-toolbar="undo redo clear | h bold italic strikethrough quote | ul ol table hr | link customimage"
							right-toolbar="aiContinue aiCreation aiCorrection aiTranslation aiDraw "
							@upload-image="onUploadImg"
							:toolbar="toolbarConfig"
						>
							
						</v-md-editor>
					</div>
				</el-form-item>

				<div class="dialog-footer">
					<el-button @click="goBack">取 消</el-button>
					<el-button type="primary" @click="editUser('addBody')">确 定</el-button>
				</div>
			</el-form>
		</el-card>

		<!-- AI组件 -->
		<Continue ref="continueRef" :content="selContent" @onAiContinue="onAiContinue" />
		<Correction ref="correctionRef" :content="selContent" @onAiCorrection="onAiCorrection" />
		<Translation ref="translationRef" :content="selContent" @onAiTranslation="onAiTranslation" />
		<Draw ref="drawRef" @onAiDraw="onAiDraw" />
		<Creation ref="creationRef" @onAiCreation="onAiCreation" />
		<Material ref="materialRef" @onAiMaterial="onAiMaterial" />
		<Menutool ref="menutoolRef" @onAiMenutool="onAiMenutool" />
		<Rewrite ref="rewriteRef" :setCurrentContentcontent="selContent" @onAiRewrite="onAiRewrite" />

	</div>
</template>

<script>
	import {
		Article,
		addArticle,
		editArticle,
		getArticleCategory
	} from "@/api/school-manage"
	import ImageUpload from "@/components/ImageUpload"
	
	import aiEditorMixin from '@/mixins/aiEditorMixin.js'

	export default {
		components: {
			ImageUpload,
		},
		mixins: [aiEditorMixin],
		data() {
			return {
				activeName: 'zh',
				formLabelWidth: '120px',
				addBody: {
					title: '',
					img: '',
					detail: '',
					desc: '',
					sub_category_id: '',
					category_id: '',
					uuid_e: '',
					title_e: '',
					img_e: '',
					detail_e: '',
					desc_e: '',
					title_j: '',
					img_j: '',
					detail_j: '',
					desc_j: '',
				},
				
				imgList: [],
				iconList: [],
				imgListEn: [],
				iconListEn: [],
				imgListJp: [],
				iconListJp: [],
				images: [],
				roleUuid: "",
				rules: {
					title: [{
						required: true,
						message: '请输入标题',
						trigger: 'blur'
					}, ],
					title_j: [{
						required: true,
						message: '请输入标题',
						trigger: 'blur'
					}, ],
					title_e: [{
						required: true,
						message: '请输入标题',
						trigger: 'blur'
					}, ],
					detail: [{
						required: true,
						message: '请输入详情',
						trigger: 'blur'
					}, ],
					detail_e: [{
						required: true,
						message: '请输入详情',
						trigger: 'blur'
					}, ],
					detail_j: [{
						required: true,
						message: '请输入详情',
						trigger: 'blur'
					}, ],
					desc: [{
						required: true,
						message: '请输入描述',
						trigger: 'blur'
					}, ],
					desc_e: [{
						required: true,
						message: '请输入描述',
						trigger: 'blur'
					}, ],
					desc_j: [{
						required: true,
						message: '请输入描述',
						trigger: 'blur'
					}, ],
					img: [{
						required: true,
						message: '请上传图片',
						trigger: 'blur'
					}, ],
					img_e: [{
						required: true,
						message: '请上传图片',
						trigger: 'blur'
					}, ],
					img_j: [{
						required: true,
						message: '请上传图片',
						trigger: 'blur'
					}, ],
					category_id: [{
						required: true,
						message: '请选择类目',
						trigger: 'blur'
					}, ],
					sub_category_id: [{
						required: true,
						message: '请选择分类',
						trigger: 'blur'
					}, ]
				},
				lmList: [{
						id: '007889c8b35bedb57876ac91f9dffc1e',
						name: '研发灵感'
					},
					{
						id: '11aa6cec60c96d23c50b8c9ff57d9427',
						name: '产品灵感'
					},
					{
						id: '54e29715-d06f-0e6168c7dfa79b594d',
						name: '营销灵感'
					},
					{
						id: '9f865cdc4ee64131a2abdb8e6762cdb4',
						name: '全部'
					}
				],
				subCategorys: []
			}
		},
		methods: {
			getCurrentContent() {
				if (this.activeName === 'zh') {
					return this.addBody.detail
				} else if (this.activeName === 'en') {
					return this.addBody.detail_e
				} else if (this.activeName === 'jp') {
					return this.addBody.detail_j
				}
				return ''
			},
			setCurrentContent(content) {
				console.log('设置当前内容:', content, this.activeName )
				if (this.activeName === 'zh') {
					this.addBody.detail = content
				} else if (this.activeName === 'en') {
					this.addBody.detail_e = content
				} else if (this.activeName === 'jp') {
					this.addBody.detail_j = content
				}
				console.log(this.addBody.content)
			},


			onUploadImg(event, insertImage, files) {
				// 这里需要根据实际的上传接口进行调整
				console.log('Upload image:', files)
				// 示例：假设上传成功后返回图片URL
				// insertImage({
				//   url: 'https://example.com/image.jpg',
				//   desc: '图片描述',
				//   width: 'auto',
				//   height: 'auto'
				// })
			},

			getCurrentEditor() {
				if (this.activeName === 'zh') {
					return this.$refs.mdEditor
				} else if (this.activeName === 'en') {
					return this.$refs.mdEditorEn
				} else if (this.activeName === 'jp') {
					return this.$refs.mdEditorJp
				}
				return null
			},
			changeTab(e) {
			},
			
			imgInput(e) {
				this.addBody.img = e[0]
			},
			imgInputEn(e) {
				this.addBody.img_e = e[0]
			},
			imgInputJp(e) {
				this.addBody.img_j = e[0]
			},
			goBack() {
				this.$router.go(-1)
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			editUser(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.addBody.uuid) {
							this.network().editArticle()
						} else {
							this.network().addArticle()
						}
					} else {
						return false;
					}
					return false
				});
			},
			unShowClick() {
				this.$emit('input', false)
			},
			network() {
				return {
					changeCategory: async (e) => {
						let postData = {
							page_size: 9999,
							page_index: 1,
							parent_id: this.addBody.category_id
						};
						const {
							status,
							data
						} = await getArticleCategory(postData);
						if (status !== 200) return;
						this.subCategorys = data.result.data
					},
					addArticle: async () => {
						const {
							status,
							data
						} = await addArticle({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('新增成功')
						this.goBack()
					},
					editArticle: async () => {
						const {
							status
						} = await editArticle({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
						this.goBack()
					},
					Article: async (uuid) => {
						const {
							data,
							status
						} = await Article({
							uuid: uuid
						})
						if (status !== 200) return
						this.addBody = data.result
						this.network().changeCategory()

						if (data.result.img != null && data.result.img) {
							this.imgList.push(data.result.img)
						}
						if (data.result.icon_e != null && data.result.icon_e) {
							this.iconListEn.push(data.result.icon_e)
						}
						if (data.result.img_e != null && data.result.img_e) {
							this.imgListEn.push(data.result.img_e)
						}
						if (data.result.icon_j != null && data.result.icon_j) {
							this.iconListJp.push(data.result.icon_j)
						}
						if (data.result.img_j != null && data.result.img_j) {
							this.imgListJp.push(data.result.img_j)
						}
						console.log(this.imgList,"imgList")
					},
				}
			},
			// 添加键盘快捷键
			addKeyboardShortcuts() {
				this.keyboardHandler = (e) => {
					// Ctrl/Cmd + Shift + A: AI续写
					if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'A') {
						e.preventDefault()
						this.onAiShow('continueRef')
					}
					// Ctrl/Cmd + Shift + C: AI创作
					else if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'C') {
						e.preventDefault()
						this.onAiShow('creationRef')
					}
					// Ctrl/Cmd + Shift + T: AI翻译
					else if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'T') {
						e.preventDefault()
						this.onAiShow('translationRef')
					}
				}
				document.addEventListener('keydown', this.keyboardHandler)
			},
			// 移除键盘快捷键
			removeKeyboardShortcuts() {
				if (this.keyboardHandler) {
					document.removeEventListener('keydown', this.keyboardHandler)
				}
			},
		},
		mounted() {
			this.addBody.uuid = this.$route.query.uuid
			if (this.addBody.uuid) {
				this.network().Article(this.addBody.uuid)
			}

			// 添加键盘快捷键支持
			this.addKeyboardShortcuts()
		},
		beforeDestroy() {
			// 移除键盘事件监听
			this.removeKeyboardShortcuts()
		}
	}
</script>

<style>
.aiIcon{
	position: relative;
	width: 28px;
                height: 28px;
}
.aiIcon::before{
		position: absolute;
		bottom: 5px;
		right: 5px;
		width: 16px;
		height: 16px;
		content: "";
		background-size: cover!important;
	}
	.ai-continue::before{
				background: url("~@/assets/images/ai/wendangbianji_icon_aixuexie@2x.png") center no-repeat ;
	}
	.ai-creation::before{
				background: url("~@/assets/images/ai/wendangbianji_icon_aichuangzuo@2x.png") center no-repeat ;
	}
	.ai-correction::before{
				background: url("~@/assets/images/ai/wendangbianji_icon_aijiucuo@2x.png") center no-repeat ;
	}
	.ai-translation::before{
				background: url("~@/assets/images/ai/wendangbianji_icon_aifanyi@2x.png") center no-repeat ;
	}
	.ai-draw::before{
				background: url("~@/assets/images/ai/wendangbianji_icon_aihuatu@2x.png") center no-repeat ;
	}
	.el-icon-back {
		font-size: 22px !important;
		cursor: pointer;
	}

	/* AI工具栏样式 */
	.ai-toolbar {
		display: flex;
		align-items: center;
		gap: 6px;
		padding: 0 10px;
		border-left: 1px solid #e8eaec;
		margin-left: 8px;
		padding-left: 12px;
	}

	.ai-btn {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 6px 8px;
		border: none;
		background: transparent;
		cursor: pointer;
		border-radius: 6px;
		font-size: 11px;
		color: #3f4a54;
		transition: all 0.2s ease;
		min-width: 50px;
		position: relative;
	}

	.ai-btn:hover {
		background-color: #f5f7fa;
		color: #409eff;
		transform: translateY(-1px);
		box-shadow: 0 2px 8px rgba(64, 158, 255, 0.1);
	}

	.ai-btn:active {
		transform: translateY(0);
	}

	.ai-btn img {
		margin-bottom: 3px;
		transition: transform 0.2s ease;
	}

	.ai-btn:hover img {
		transform: scale(1.1);
	}

	/* AI续写按钮特殊样式 */
	.ai-btn[title="AI续写"] {
		background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
		color: white;
		font-weight: 500;
	}

	.ai-btn[title="AI续写"]:hover {
		background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
		color: white;
		box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
	}

	/* v-md-editor样式调整 */
	.v-md-editor {
		border: 1px solid #dcdfe6;
		border-radius: 4px;
	}

	.v-md-editor--fullscreen {
		z-index: 2000;
	}
	.v-md-editor__toolbar-left+.v-md-editor__toolbar-right{
		    margin-left: 20px;
	}
</style>